





import {Vue, Component} from 'nuxt-property-decorator'

@Component
export default class MenuCmsPage extends Vue {
  asyncDataHost: any;
  homePageAlias: any;

  async asyncData(context: any): Promise<object | void> {
    const homePageAlias: string = await context.$api.agent.transport.get('/cms/home').then((res: any) => {
      return res.data?.page?.alias
    }).catch(() => {
      return ""
    });

    return {
      asyncDataHost: context?.req?.headers?.host,
      homePageAlias: homePageAlias
    }
  }

  get path(): string {
    const subdomainForJJ = process.env.subdomainForJJ;
    const homePageForSubdomainForJJ = process.env.homePageForSubdomainForJJ;
    if (!subdomainForJJ || !homePageForSubdomainForJJ) {
      return this.$route.path === '/' ? 'homepage' : this.$route.path
    }

    const host = (this.asyncDataHost || window?.location.host).split(`${subdomainForJJ}.`).length;
    if (host > 1) {
      return this.$route.path === '/' ? homePageForSubdomainForJJ : this.$route.path
    }

    return this.$route.path === '/' ? 'homepage' : this.$route.path
  }
}
